define('GameDayCore/GDUtil/dataMapping/GameReferenceNormalizer',['require','exports','module','gameday-index-enums/enums/baseball/GIDDecoder'],function(require, exports, module) {
	var GID = require("gameday-index-enums/enums/baseball/GIDDecoder");

	exports.storeVal = function(game) {
		var gid = new GID(game);
		return gid.gid_path;
	};

	exports.displayVal = function(game) {
		var gid = new GID(game);
		return gid;
	};
});
